import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

export default class CustomTextarea extends Component {
    static propTypes = {
        value: PropTypes.string,
        placeholder: PropTypes.string,
        blurOnEnter: PropTypes.bool,
        editable: PropTypes.bool,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        onKeydown: PropTypes.func,
        provideController: PropTypes.func
    };

    static defaultProps = {
        value: '',
        placeholder: '',
        editable: true
    }

    focused = false;

    state = {
        value: this.props.value
    }

    handleInput = () => {
        const value = this.element.textContent;

        this.setState({ value });

        this.props.onChange && this.props.onChange(value);
    }

    handleBlur = () => {
        this.focused = false;
        this.props.onBlur && this.props.onBlur(this.element.textContent);
    }

    handleFocus = () => {
        this.focused = true;
        this.props.onFocus && this.props.onFocus();
    }

    handleKeyDown = event => {
        if (this.props.blurOnEnter && event.which === 13) {
            event.preventDefault();
            this.blur();
        }

        this.props.onKeyDown && this.props.onKeyDown(event);
    }

    focus() {
        this.element && this.element.focus();
    }

    blur() {
        this.element && this.element.blur();
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            focus: () => {
                this.focus();
            },
            blur: () => {
                this.blur();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== this.element.textContent) {
            this.setState({
                value: this.props.value
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            (nextProps.value !== this.element.textContent && !this.focused) ||
            this.props.editable !== nextProps.editable
        ) {
            return true;
        }

        return false;
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        return (
            <div
                className="custom-textarea"
                ref={element => this.element = element}
                contentEditable={this.props.editable}
                placeholder={this.props.placeholder}
                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.state.value)}}
                onInput={this.handleInput}
                onBlur={this.handleBlur}
                onFocus={this.handleFocus}
                onKeyDown={this.handleKeyDown}
            />
        )
    }
}
